import React, { createContext, useContext, useState, useCallback } from 'react'
import ConfirmDialog from '../Components/Dialogs/ConfirmDialog'
import { redirectSmart } from '../Global/Functions'

const DialogContext = createContext(null)

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    open: false,
    title: '',
    content: '',
    yesAction: null,
    noAction: null,
    acceptButton: null,
    rejectButton: null,
    videoControl: false,
  })

  const confirm = useCallback((params) => {
    setDialogState({
      open: true,
      title: params.title || 'Confirm',
      content: params.content || '',
      yesAction: params.onYes || (() => {}),
      noAction: params.onNo || (() => {}),
      acceptButton: params.acceptButton,
      rejectButton: params.rejectButton,
      videoControl: params.videoControl ?? false,
    })
  }, [])

  const getTheApp = useCallback(() => {
    setDialogState({
      title: 'Heads up!',
      content:
        'This feature works best on a desktop or laptop. For the best mobile experience, try our native mobile app.',
      yesAction: () => {
        redirectSmart()
      },
      noAction: () => {},
      acceptButton: 'Lets Go!',
      rejectButton: 'Skip',
      open: true,
      videoControl: false,
    })
  }, [])

  const close = useCallback(() => {
    setDialogState((prev) => ({ ...prev, open: false }))
  }, [])

  return (
    <DialogContext.Provider value={{ confirm, getTheApp, close }}>
      {children}

      {/* The dialog is mounted once and controlled from context */}
      <ConfirmDialog
        open={dialogState.open}
        setOpen={(v) => setDialogState((prev) => ({ ...prev, open: v }))}
        title={dialogState.title}
        content={dialogState.content}
        yesAction={() => {
          dialogState.yesAction?.()
          close()
        }}
        noAction={() => {
          dialogState.noAction?.()
          close()
        }}
        acceptButton={dialogState.acceptButton}
        rejectButton={dialogState.rejectButton}
        videoControl={dialogState.videoControl}
      />
    </DialogContext.Provider>
  )
}

export const useDialog = () => useContext(DialogContext)
